var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiologie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.667 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2451",
    fill: "currentColor",
    d: "M0 0h50.667v62H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 954",
    clipPath: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 903",
    d: "M32.909 23.183c1.777-.062 2.966-.23 3.338-1.02.914-1.077.772-6.538-3.619-4.694-1.987.834-3.7 1.5-3.459 2.384.8 3.459 2.067 3.387 3.741 3.33"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 904",
    d: "M25.118 27.502c.907 0 .752-1.067 1.258-1.075.48-.01.258 1.075 1.191 1.075a1.03 1.03 0 0 0 .266-.034.95.95 0 0 0 .669-1.17 11.661 11.661 0 0 0-1.343-2.648.955.955 0 0 0-1.633 0 11.822 11.822 0 0 0-1.343 2.648 1.016 1.016 0 0 0-.034.266.953.953 0 0 0 .969.938"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 905",
    d: "M19.881 23.183c1.674.057 2.945.129 3.741-3.33.241-.889-1.472-1.55-3.459-2.385-4.392-1.844-4.534 3.617-3.619 4.694.372.79 1.56.958 3.338 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 906",
    d: "M44.542 0H6.125A6.127 6.127 0 0 0 0 6.125v49.75A6.125 6.125 0 0 0 6.125 62h38.417a6.123 6.123 0 0 0 6.125-6.125V6.125A6.125 6.125 0 0 0 44.542 0M13.475 17.763A11.939 11.939 0 0 1 25.314 5.722h2.152a11.943 11.943 0 0 1 11.842 12.041V24.6A4.342 4.342 0 0 1 35 28.972h-2.383L30.7 34.139h-8.61l-1.922-5.167h-2.39a4.338 4.338 0 0 1-4.3-4.376Zm-3.23 34.459a1.938 1.938 0 0 1-3.875 0v-5.167a1.938 1.938 0 1 1 3.875 0Zm36.167 0a1.938 1.938 0 0 1-3.875 0v-5.167a1.938 1.938 0 1 1 3.875 0Zm-.15-9.587a1.94 1.94 0 0 1-2.534 1.044l-7.1-2.958-8.3 2.594v3.043l7.817-2.441a1.938 1.938 0 1 1 1.155 3.7l-8.972 2.806v2.917l7.817-2.444a1.938 1.938 0 1 1 1.155 3.7L26.391 58l-10.912-3.41a1.938 1.938 0 1 1 1.155-3.7l7.82 2.444v-2.915l-8.974-2.806a1.938 1.938 0 1 1 1.155-3.7l7.82 2.441v-3.039l-8.3-2.594-7.1 2.958A1.94 1.94 0 0 1 7.561 40.1l8.4-3.5 8.491 2.653V37.5h3.875v1.757l8.491-2.657 8.4 3.5a1.938 1.938 0 0 1 1.044 2.534"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiologie);
export default __webpack_public_path__ + "static/media/radiologie.c5437be858ee37a4967ed5fd45dc3dcf.svg";
export { ForwardRef as ReactComponent };